import { useQuery } from '@apollo/client';
import { graphql } from '@app/graphql/types';
import { BannerPlatform } from '@app/graphql/types/graphql';

const QUERY = graphql(`
  query storefront_getAvailableNewsBanner($companyId: ID!, $filter: AvailableNewsBannerFilter!) {
    storefront_getAvailableNewsBanner(companyId: $companyId, filter: $filter) {
      id
      title
      description
      startTime
      endTime
      isActive
      platforms
      imageUrl
      allowPopup
    }
  }
`);

export default function useNewsBanners(companyId: string, filter: { platforms: BannerPlatform }) {
  return useQuery(QUERY, {
    variables: {
      companyId: companyId,
      filter,
    },
  });
}
